import React from 'react';
import { Check } from 'lucide-react';
export function BonusSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="bonus" className="py-8 sm:py-16 bg-[#0f172a] relative" data-id="element-30">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-31">
        <div className="text-center mb-6 sm:mb-10" data-id="element-32">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-33">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-sm sm:text-base text-gray-300 max-w-2xl mx-auto mb-4" data-id="element-34">
            Para que tengas respaldo profesional y el año completamente
            organizado, incluimos 2 bonus estratégicos:
          </p>
          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-sm sm:text-lg px-6 py-2 rounded-lg shadow-lg border-2 border-white/20 animate-pulse" data-id="element-35">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-36">
          {/* BONUS 1 */}
          <div className="bg-[#1e293b] rounded-2xl overflow-hidden border-4 border-[#fbbf24] shadow-2xl shadow-[#fbbf24]/20 flex flex-col" data-id="element-37">
            <div className="bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] p-3 sm:p-4 text-center" data-id="element-38">
              <h3 className="text-lg sm:text-2xl font-black text-[#0a1628]" data-id="element-39">
                🎁 BONUS 1
              </h3>
            </div>
            <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-40">
              <div className="w-full mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/vy5ZJCwe3ffAbhr94VoqAR/bonus_1_.png" alt="Banco Profesional de Proyectos Sociales" className="w-full h-auto object-contain rounded-lg shadow-xl" data-id="element-42" />
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-[#fbbf24] mb-2 text-center" data-id="element-43">
                Banco Profesional de Proyectos Sociales
              </h4>
              <p className="text-gray-300 text-sm sm:text-base mb-4 text-center" data-id="element-44">
                Proyectos completos en Ciencias Sociales listos para aplicar.
              </p>
              <p className="text-gray-400 text-xs sm:text-sm mb-3 font-medium" data-id="element-45">
                Incluye:
              </p>
              <ul className="space-y-2 flex-1" data-id="element-46">
                {['Problema delimitado', 'Objetivos e hipótesis', 'Encuestas y entrevistas listas', 'Ejemplo de correlación', 'Categorías cualitativas', 'Conclusiones modelo'].map((item, i) => <li key={i} className="flex items-center text-gray-200 text-xs sm:text-sm" data-id="element-47">
                    <Check className="h-4 w-4 text-[#16a34a] mr-2 flex-shrink-0" strokeWidth={3} data-id="element-48" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* BONUS 2 */}
          <div className="bg-[#1e293b] rounded-2xl overflow-hidden border-4 border-[#fbbf24] shadow-2xl shadow-[#fbbf24]/20 flex flex-col" data-id="element-49">
            <div className="bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] p-3 sm:p-4 text-center" data-id="element-50">
              <h3 className="text-lg sm:text-2xl font-black text-[#0a1628]" data-id="element-51">
                🎁 BONUS 2
              </h3>
            </div>
            <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-52">
              <div className="w-full mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-53">
                <img src="https://cdn.magicpatterns.com/uploads/jgmYmumcTLtJksBBCqw7Fu/mockups_planificacion.png" alt="Planificación Anual Lista" className="w-full h-auto object-contain rounded-lg shadow-xl" data-id="element-54" />
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-[#fbbf24] mb-2 text-center" data-id="element-55">
                Planificación Anual Lista
              </h4>
              <p className="text-gray-300 text-sm sm:text-base mb-4 text-center" data-id="element-56">
                Organizá todo tu año de Metodología en Ciencias Sociales sin
                improvisar.
              </p>
              <p className="text-gray-400 text-xs sm:text-sm mb-3 font-medium" data-id="element-57">
                Incluye:
              </p>
              <ul className="space-y-2 flex-1" data-id="element-58">
                {['Cronograma mensual', 'Secuencia del proyecto final', 'Entregas parciales organizadas', 'Sistema de evaluación trimestral', 'Rúbrica profesional', 'Plantilla editable de informe'].map((item, i) => <li key={i} className="flex items-center text-gray-200 text-xs sm:text-sm" data-id="element-59">
                    <Check className="h-4 w-4 text-[#16a34a] mr-2 flex-shrink-0" strokeWidth={3} data-id="element-60" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}